export const ENV = () => {
  if (window.location.hostname.includes('localhost')) return 'local';
  if (window.location.hostname.includes('polp-mx-dev')) return 'development-mx';
  if (window.location.hostname.includes('polp-dev')) return 'development';
  if (window.location.hostname.includes('polpbyedelvives.com.mx')) return 'production-mx';
  if (window.location.hostname.includes('polpbyedelvives.com')) return 'production';
  return 'production';
};
